import React from 'react';
import ChartLineIcon from 'mdi-react/ChartLineIcon';
import AccountsPlusIcon from 'mdi-react/AccountsPlusIcon';
import CreditCardMultipleIcon from 'mdi-react/CreditCardMultipleIcon';
import SeatIcon from 'mdi-react/SeatIcon';
import BankTransferIcon from 'mdi-react/BankTransferIcon';
import ShieldCheckIcon from 'mdi-react/ShieldCheckIcon';
import SaleIcon from 'mdi-react/SaleIcon';
import DatabaseSettingsIcon from 'mdi-react/DatabaseSettingsIcon';
import CreditCardSettingsIcon from 'mdi-react/CreditCardSettingsIcon';
import MessageTextClockIcon from 'mdi-react/MessageTextClockIcon';
import SwapHorizontalIcon from 'mdi-react/SwapHorizontalIcon';

import { USER_RIGHTS } from '@crm-package/auth';

export default [
  {
    component: React.lazy(
      async () =>
        import(/* webpackChunkName: "lead-details" */ '@crm-lead/lead-details')
    ),
    requiredRights: [
      USER_RIGHTS.DETAILS_VIEW_ALL,
      USER_RIGHTS.DETAILS_VIEW_ASSIGNED,
    ],
    key: 'lead-details',
    path: '/',
    exact: true,
    title: 'Details',
    icon: ChartLineIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(/* webpackChunkName: "lead-marketing" */ '@crm-lead/marketing')
    ),
    requiredRights: [
      USER_RIGHTS.DETAILS_VIEW_ALL,
      USER_RIGHTS.DETAILS_VIEW_ASSIGNED,
    ],
    key: 'lead-marketing',
    path: '/marketing',
    exact: true,
    title: 'Marketing',
    icon: AccountsPlusIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(
          /* webpackChunkName: "marketing-events" */ '@crm-lead/marketing-events'
        )
    ),
    requiredRights: [USER_RIGHTS.MARKETING_EVENTS_HISTORY],
    key: 'marketing-events',
    path: '/marketing-events',
    exact: true,
    title: 'Marketing Events',
    icon: SeatIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(/* webpackChunkName: "lead-trading" */ '@crm-lead/trading')
    ),
    requiredRights: [
      USER_RIGHTS.DETAILS_VIEW_ALL,
      USER_RIGHTS.DETAILS_VIEW_ASSIGNED,
    ],
    key: 'lead-trading',
    path: '/trading',
    exact: true,
    title: 'Trading',
    icon: BankTransferIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(
          /* webpackChunkName: "lead-transactions-report" */ '@crm-lead/transactions-report'
        )
    ),
    requiredRights: [
      USER_RIGHTS.TRANSACTION_VIEW_ALL,
      USER_RIGHTS.TRANSACTION_VIEW_ASSIGNED,
    ],
    key: 'lead-transactions-report',
    path: '/transactions-report',
    exact: true,
    title: 'Transactions Report',
    icon: CreditCardMultipleIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(/* webpackChunkName: "lead-compliance" */ '@crm-lead/compliance')
    ),
    requiredRights: [USER_RIGHTS.VIEW_COMPLIANCE_INFO],
    key: 'lead-compliance',
    path: '/compliance',
    exact: true,
    title: 'Compliance',
    icon: ShieldCheckIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(
          /* webpackChunkName: "lead-transactions" */ '@crm-lead/transactions'
        )
    ),
    requiredRights: [
      USER_RIGHTS.CREDIT_CARD_CLEAR_ALL,
      USER_RIGHTS.CREDIT_CARD_CLEAR_ASSIGNED,
      USER_RIGHTS.CREATE_DEPOSIT_ALL,
      USER_RIGHTS.CREATE_DEPOSIT_ASSIGNED,
      USER_RIGHTS.ALLOW_TOKENEXUS_LINK_GENERATION,
      USER_RIGHTS.ALLOW_VAHETUS_PAYMENTS_LINK_GENERATION,
      USER_RIGHTS.ALLOW_CRYPTOWALLET_LINK_GENERATION,
      USER_RIGHTS.PRIOR_BONUS_ALL,
      USER_RIGHTS.PRIOR_BONUS_ASSIGNED,
      USER_RIGHTS.CREATE_CHARGEBACK,
      USER_RIGHTS.CREATE_RECALL,
      USER_RIGHTS.CREATE_RECALL,
      USER_RIGHTS.CREATE_CREDIT_ALL,
      USER_RIGHTS.CREATE_CREDIT_ASSIGNED,
      USER_RIGHTS.CREATE_DEBIT_ALL,
      USER_RIGHTS.CREATE_DEBIT_ASSIGNED,
      USER_RIGHTS.CREATE_TRANSFER_BALANCE_ALL,
      USER_RIGHTS.CREATE_TRANSFER_BALANCE_ASSIGNED,
      USER_RIGHTS.CREATE_WITHDRAW_REQUEST_ALL,
      USER_RIGHTS.CREATE_WITHDRAW_REQUEST_ASSIGNED,
    ],
    key: 'lead-transactions',
    path: '/transactions',
    exact: true,
    title: 'Transactions',
    icon: SwapHorizontalIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () => import(/* webpackChunkName: "lead-promo" */ '@crm-lead/promo')
    ),
    requiredRights: [USER_RIGHTS.ACCOUNTS_PROMO_VIEW],
    key: 'lead-promo',
    path: '/promo',
    exact: true,
    title: 'Promo',
    icon: SaleIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(
          /* webpackChunkName: "web-app-setting" */ '@crm-lead/web-app-settings'
        )
    ),
    requiredRights: [USER_RIGHTS.VIEW_WEBAPP_SETTINGS],
    key: 'web-app-settings',
    path: '/web-app-settings',
    exact: true,
    title: 'Web App Settings',
    icon: DatabaseSettingsIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(
          /* webpackChunkName: "lead-card-processing-settings" */ '@crm-lead/card-processing-settings'
        )
    ),
    requiredRights: [USER_RIGHTS.EDIT_LEAD_CARD_PROCESSING_SETTINGS],
    key: 'card-processing-settings',
    path: '/lead-card-processing-settings',
    exact: true,
    title: 'Card Processing Settings',
    icon: CreditCardSettingsIcon,
    inMenu: true,
  },
  {
    component: React.lazy(
      async () =>
        import(/* webpackChunkName: "sms-history" */ '@crm-lead/sms-history')
    ),
    requiredRights: [USER_RIGHTS.SMS_SIGNALS_HISTORY_VIEW],
    key: 'sms-history',
    path: '/sms-history',
    exact: true,
    title: 'Sms History',
    icon: MessageTextClockIcon,
    inMenu: true,
  },
] as const;
